export const GET_QUESTIONS = 'legend/assessmentSectionQuestions/GET_QUESTIONS';
export const GET_QUESTIONS_SUCCESS = 'legend/assessmentSectionQuestions/GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_FAIL = 'legend/assessmentSectionQuestions/GET_QUESTIONS_FAIL';

export const SAVE_QUESTIONS_PROGRESS = 'legend/assessmentSectionQuestions/SAVE_QUESTIONS_PROGRESS';
export const SAVE_QUESTIONS_PROGRESS_SUCCESS = 'legend/assessmentSectionQuestions/SAVE_QUESTIONS_PROGRESS_SUCCESS';
export const SAVE_QUESTIONS_PROGRESS_FAIL = 'legend/assessmentSectionQuestions/SAVE_QUESTIONS_PROGRESS_FAIL';

export const SAVE_PARTIAL_QUESTIONS_PROGRESS = 'legend/assessmentSectionQuestions/SAVE_PARTIAL_QUESTIONS_PROGRESS';
export const SAVE_PARTIAL_QUESTIONS_PROGRESS_SUCCESS = 'legend/assessmentSectionQuestions/SAVE_PARTIAL_QUESTIONS_PROGRESS_SUCCESS';
export const SAVE_PARTIAL_QUESTIONS_PROGRESS_FAIL = 'legend/assessmentSectionQuestions/SAVE_PARTIAL_QUESTIONS_PROGRESS_FAIL';

// RESET
export const RESET_ASSESSMENT_QUESTIONS = 'legend/assessmentSectionQuestions/RESET_ASSESSMENT_QUESTIONS';
